(function(){
  function setPreviewMode(){
    if(window.Shopify && window.Shopify.previewMode){
      document.body.classList.add('af-theme-preview');
    }
  }

  function initProductEnhancements(root){
    root = root || document;

    root.querySelectorAll('.af-product-desc iframe').forEach(function(frame){
      frame.setAttribute('loading', 'lazy');
      frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      frame.setAttribute('allowfullscreen', '');
      if(!frame.getAttribute('title')) frame.setAttribute('title', 'Arabian Farms product video');
    });

    root.querySelectorAll('[data-product-detail]').forEach(function(productRoot){
      if(productRoot.dataset.seoCroReady === '1') return;
      productRoot.dataset.seoCroReady = '1';

      var pairings = productRoot.querySelector('[data-af-pairings]');
      if(pairings){
        pairings.querySelectorAll('[data-af-pairing-card]').forEach(function(card){
          var select = card.querySelector('[data-af-pairing-variant]');
          var price = card.querySelector('[data-af-pairing-price]');
          var addButton = card.querySelector('[data-af-pairing-add]');

          if(select && select.tagName === 'SELECT'){
            select.addEventListener('change', function(){
              var option = select.options[select.selectedIndex];
              if(price && option && typeof window.formatMoney === 'function') price.textContent = window.formatMoney(option.dataset.price);
            });
          }
          if(addButton){
            addButton.addEventListener('click', function(){
              if(addButton.disabled || !select || typeof window.afAddVariantToCart !== 'function') return;
              addButton.disabled = true;
              addButton.textContent = pairings.dataset.addingLabel;
              window.afAddVariantToCart(select.value, 1, false)
                .then(function(){ addButton.textContent = pairings.dataset.addedLabel; })
                .catch(function(){
                  addButton.textContent = pairings.dataset.retryLabel;
                  window.setTimeout(function(){ addButton.disabled = false; }, 1200);
                });
            });
          }
        });
      }

      var bar = productRoot.querySelector('[data-mobile-buybar]');
      var mainButton = productRoot.querySelector('[data-product-add-icon]');
      var mainPrice = productRoot.querySelector('[data-product-price]');
      if(!bar || !mainButton) return;
      var mobileButton = bar.querySelector('[data-mobile-add]');
      var mobilePrice = bar.querySelector('[data-mobile-price]');

      function sync(){
        if(mobilePrice && mainPrice) mobilePrice.textContent = mainPrice.textContent;
        if(mobileButton){
          mobileButton.disabled = mainButton.disabled;
          var label = mainButton.querySelector('[data-product-add-text]');
          mobileButton.textContent = label ? label.textContent : mainButton.textContent;
        }
      }
      sync();

      if(window.MutationObserver){
        var observer = new MutationObserver(sync);
        observer.observe(mainButton, {attributes:true, attributeFilter:['disabled']});
        if(mainPrice) observer.observe(mainPrice, {childList:true, characterData:true, subtree:true});
      }
      if(mobileButton){
        mobileButton.addEventListener('click', function(){
          if(!mainButton.disabled) mainButton.click();
        });
      }

      bar.classList.add('is-hidden');
      var scrollTicking = false;
      function updateBarVisibility(){
        var buttonRect = mainButton.getBoundingClientRect();
        var hasPassedMainButton = buttonRect.bottom <= 0;
        bar.classList.toggle('is-hidden', !hasPassedMainButton);
        bar.classList.add('is-ready');
      }
      function scheduleBarUpdate(){
        if(scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(function(){
          updateBarVisibility();
          scrollTicking = false;
        });
      }
      window.addEventListener('scroll', scheduleBarUpdate, {passive:true});
      window.addEventListener('resize', scheduleBarUpdate);
      updateBarVisibility();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      setPreviewMode();
      initProductEnhancements(document);
    });
  }else{
    setPreviewMode();
    initProductEnhancements(document);
  }
  document.addEventListener('shopify:section:load', function(event){ initProductEnhancements(event.target || document); });
})();

